<div #feedScroller class="max-w-lg mx-auto flex-col pt-20">
  <div class="flex-1 bg-theme-surface-95 backdrop-blur-2xl rounded-t-3xl min-h-[calc(100vh-5rem)]">
    <div class="flex flex-row pt-6 px-4 pb-4 items-center">
      <div class="mr-3">
        <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl" (onClick)="back()"></app-circle-button>
      </div>
      <div class="ml-2 break-words w-[calc(100%-3rem)] flex-col text-theme-text">
        <div class="text-3xl">{{title}}</div>
        <div *ngIf="inhouse && !isKioskModeActive()" class="py-1"><app-link-button [text]="getString('Byt bord')" leftIcon="fa-shuffle" (onClick)="changeTable()"></app-link-button></div>
        <div *ngIf="roomservice && !isKioskModeActive()" class="py-1"><app-link-button [text]="getString('Byt rum')" leftIcon="fa-shuffle" (onClick)="changeRoom()"></app-link-button></div>
      </div>
    </div>
    <div *ngIf="false" class="px-8 mt-10">
      <div>{{getString("Du har inte lagt till något i din beställning ännu. Välj mat och dryck från menyn.")}}</div>
    </div>

    <!-- Completed prebooking confirmation -->
    <div *ngIf="prebookBooked" class="px-4 mt-2">
      <div class="bg-theme-surface2 rounded-xl p-4 text-theme-text">
        <div class="font-bold text-lg">
          <i class="fas fa-circle-check text-green-600 mr-2"></i>{{getString("Din förbokning är genomförd")}}
        </div>
        <div class="mt-1 text-sm text-theme-text3">{{getString("Bokningsnummer")}} {{prebookExternalRef || prebookBooked.booking_ref}}</div>
        <div class="mt-4">
          <app-page-button [text]="getString('Visa bokning')" icon="fa-calendar-check" (onClick)="openPrebookBooking()"></app-page-button>
        </div>
      </div>
    </div>

    <div class="px-4 mt-8">

      <div *ngFor="let event of events; let last = last; let first = first;">
        <div *ngIf="first && hasOlderEvents && (showLatest || show6Hour)" class="flex">
          <div class="w-6 relative flex justify-center">
            <div class="rounded-full bg-theme-notification w-6 h-6"></div>
            <div class="absolute top-0 bottom-0 w-1.5 bg-theme-notification"></div>
          </div>
          <div class="pl-2 flex-1 w-full">
            <div class="-mt-0.5 flex gap-2 relative">
              <div *ngIf="showLatest" class="text-theme-text3" (click)="showOlderEvents()">{{ getString("Visa tidigare händelser") }}</div>
              <div *ngIf="show6Hour" class="text-theme-text3" (click)="showOlderEvents()">{{ getString("Visa äldre händelser") }}</div>
            </div>
          </div>
          <div class="h-12"></div>
        </div>
        <div class="flex">
          <div class="w-6 relative flex justify-center">
            <div class="rounded-full bg-theme-notification w-6 h-6"></div>
            <div *ngIf="!last" class="absolute top-0 bottom-0 w-1.5 bg-theme-notification"></div>
          </div>
          <div class="pl-2 flex-1 w-full">
            <div class="-mt-0.5 flex gap-2 relative text-theme-text">
              <div *ngIf="event.dateString" class="absolute -top-4 text-sm text-theme-text">{{event.dateString}}</div>
              <div class="font-bold text-lg shrink-0">{{event.timeString}}</div>
              <div *ngIf="event.content" class="text-lg break-words min-w-0">{{translate.getString(event.title)}}</div>
              <div *ngIf="!event.content" class="break-words" [innerHTML]="translateTitle(event.title)" (click)="bgClick()"></div>
            </div>

            <div *ngIf="event.content?.order_items" class="mt-4 bg-theme-surface2 p-3 rounded-xl text-theme-text">
              <div class="grid grid-cols-[auto_1fr_auto] gap-2">
                <ng-container *ngFor="let item of event.content?.order_items">
                  <div class="tabular-nums">{{item.quantity}}</div>

                  <div class="min-w-0">
                    <div class="break-words">{{translate.getString(item.name)}}</div>
                    <div class="break-words text-sm text-theme-text3" *ngIf="item.comment">{{ translate.translateItemComment(item.comment) }}</div>
                  </div>

                  <div class="tabular-nums text-end">{{item.formatted_item_total}}</div>
                </ng-container>

                <!-- Total row -->
                <div class="col-span-2 mt-4">{{translate.getString('Totalt')}}</div>
                <div class="tabular-nums mt-4 font-bold text-end">{{event.content?.total_formatted}}</div>

              </div>
            </div>

            <div *ngIf="event.type==='image'" [class]="event.class">
              <div class="flex justify-center"><img class="w-full max-w-100" [src]="event.url"></div>
              <div class="when">{{event.timeString}}</div>
            </div>

            <!-- receipt -->
            <div *ngIf="!event.content && event.type==='generic' && !event.vouchers">
              <div *ngFor="let btn of event.buttons" class="mt-4 mx-4">
                <app-page-button [text]="getString(btn.title)" (onClick)="clicked(btn)" icon="fa-receipt"></app-page-button>
              </div>
            </div>

            <!-- voucher -->
            <div class="mt-4 bg-theme-surface p-4 rounded-xl text-theme-text" *ngIf="!event.content && event.type==='generic' && event.vouchers">
              <div *ngIf="event.vouchers">
                <div class="mt-4" *ngFor="let o of event.vouchers">
                  <app-dragger [voucher]="o" [venueId]="appState!.venueId" [type]="'feed'" [price]="getFormattedPrice(o.price, o.id)"></app-dragger>
                </div>
                <div class="mt-4 px-2 text-sm font-light italic text-theme-text">
                  <p class="text-justify">{{getString(translate.STRING_ACTIVATE1)}}</p>
                  <p class="mt-3">{{getString(translate.STRING_ACTIVATE2)}}</p>
                </div>
              </div>
              <div *ngFor="let btn of event.buttons" class="mt-6">
<!--                <app-plain-button [text]="getString(btn.title)" (click)="clicked(btn)"></app-plain-button>-->
                <app-page-button [text]="getString(btn.title)" (onClick)="clicked(btn)" icon="fa-receipt"></app-page-button>
              </div>
            </div>

            <div [ngClass]="{'h-12':event.dateString, 'h-10':!event.dateString}"></div>

          </div>
        </div>
      </div>


      <!--        <div *ngIf="event.type==='text'" [class]="event.class">-->
      <!--          <div class="break-words" [innerHTML]="translateTitle(event.title)" (click)="bgClick()"></div>-->
      <!--          <div class="when">{{event.timeString}}</div>-->
      <!--        </div>-->
      <!--        <div *ngIf="event.type==='image'" [class]="event.class">-->
      <!--          <div class="flex justify-center"><img class="w-full max-w-100" [src]="event.url"></div>-->
      <!--          <div class="when">{{event.timeString}}</div>-->
      <!--        </div>-->
      <!--        <div *ngIf="event.type==='generic'" [class]="event.class">-->
      <!--          <div *ngIf="event.topImg" class="-mt-4 -mx-4 mb-4"><img [src]="event.topImg" class="max-h-44 w-full object-cover rounded-t-[1.3em]"></div>-->
      <!--          <div class="font-bold pb-1">{{translateTitle(event.title)}}</div>-->
      <!--          <div *ngIf="event.subtitle" class="text-sm pb-3 text-gray-700">{{translateSubTitle(event.subtitle)}}</div>-->
      <!--          <div *ngFor="let btn of event.buttons">-->
      <!--            <app-plain-grey-button [text]="getString(btn.title)" (click)="clicked(btn)"></app-plain-grey-button>-->
      <!--          </div>-->
      <!--          <div *ngIf="event.vouchers" class="mt-5">-->
      <!--            <div *ngFor="let o of event.vouchers">-->
      <!--              <app-dragger [voucher]="o" [venueId]="appState!.venueId" [type]="'feed'"></app-dragger>-->
      <!--            </div>-->
      <!--            <div class="pt-4 text-sm font-light italic text-gray-700">-->
      <!--              <p>{{getString(translate.STRING_ACTIVATE1)}}</p>-->
      <!--              <p class="mt-1">{{getString(translate.STRING_ACTIVATE2)}}</p>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="when pt-4">{{event.timeString}}</div>-->
      <!--        </div>-->

    </div>

    <!-- Review rating section (after payment link) -->
    @if (showReview) {
    <div class="flex flex-col items-center px-6 mt-4 mb-12">
      @if (showThankYouState) {
        <div class="w-full max-w-xs">
          <app-action-button
            [text]="translate.getString('Betygsätt på Google')"
            icon="fa-arrow-up-right-from-square"
            [chevron]="false"
            (onClick)="openGoogleReview()">
          </app-action-button>
        </div>
      } @else {
        <div class="text-xl font-bold text-theme-text text-center">
          {{ reviewService.reviewSubmitted ? translate.getString(reviewService.thankYouText) : translate.getString(reviewService.reviewText) }}
        </div>
        <div class="mt-4">
          <app-star-rating [rating]="reviewService.overallRating"
            (ratingChange)="onOverallRatingSelected($event)" size="lg">
          </app-star-rating>
        </div>
      }
    </div>
    }

    <div class="h-24">
      <!--      bottom spacer-->
    </div>
  </div>
</div>

<div class="max-w-lg mx-auto fixed bottom-0 left-0 right-0 bg-theme-surface">
  <div class="grid auto-cols-fr grid-flow-col gap-3 p-2">
    <app-square-button *ngIf="showCallForWaitress && !isKioskMode" [text]="translate.getString('Kalla på servis')" icon="fa-hand-pointer" (onClick)="callForWaitress()"></app-square-button>
    <app-square-button [text]="translate.getString('Se menyn')" icon="fa-map" (onClick)="navMenu()"></app-square-button>
    <app-square-button *ngIf="isOpenTable && !isKioskMode" [text]="translate.getString('Betala notan')" icon="fa-wallet" (onClick)="navLivesplit()"></app-square-button>
  </div>
</div>

<!--<div *ngIf="showConsole" style="position: absolute; top:37px;left:8px;z-index: 10;padding: 8px;background-color: gainsboro;border-radius: 5px;">-->
<!--  <input type="text" style="height:30px;border:none;width: 200px;font-size: 16px;" [(ngModel)]="message">-->
<!--  <button mat-stroked-button style="margin-left:4px;font-size: 15px;" (click)="go()"><mat-icon>send</mat-icon></button>-->
<!--</div>-->
